<div class="edit-customer-root">
  <div class="edit-customers-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
            {{ paymentHistory?.customer?.name | hasValue }}
        </div>
        <div class="slrn">
          {{ paymentHistory?.customer?.accountNumber | hasValue }}
        </div>
        <div class="row info-row">
          <div *ngIf="paymentHistory?.paymentStatus" class="building-status building-status-margin-right" 
            [ngClass]="{'rejected-building': paymentHistory?.paymentStatus == 'Failed',
                        'approved-building': paymentHistory?.paymentStatus == 'Success',
                        'submitted-building': paymentHistory?.paymentStatus=='Pending'}"
            >
            {{ ('COMMON.PAYMENT_STATUS.' + paymentHistory?.paymentStatus | uppercase | translate) }}
          </div>
          <div *ngIf="!paymentHistory?.paymentStatus" class="building-status-margin-right">
                ----
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ paymentHistory?.customer?.email | hasValue }}</div>
        <div>{{ paymentHistory?.customer?.phoneNumber | hasValue }}</div>
        <div>{{ paymentHistory?.amount != null ? ((paymentHistory?.amount | number:'1.0-0') + ' ' + currency) : '----' }}</div>
      </div>
    </div>
    
  </div>
    <div class="edit-customers-body">
        <div class="main-col">
            <div class="card container">
                <div class="row">
                    <div class="col-5">
                        <p class="card-title">{{ 'PAYMENT_HISTORY.CUSTOMER_INFORMATION' | translate }}</p>
                    </div>
                    <div class="col-7">
                        <div class="line-2"></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.CUSTOMER_NAME' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.name | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.EMAIL_ADDRESS' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.email | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.PHONE_NUMBER' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.phoneNumber | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.ACCOUNT_NUMBER' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.accountNumber | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.SPN' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.spn | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.APPLICATION_NUMBER' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.accountKyc?.applicationNumber | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.MAP_ID' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.mapId | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.SERVICE_ORDER_ID' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.accountKyc?.serviceOrderId | hasValue }}</div>
                </div>

                <div class="row">
                  <div class="col-5">{{ 'COMMON.MBC_DETAILS.METER_PHASE' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.typeOfConnection | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.SERVICE_REQUEST_TYPE' | translate }}</div>
                    <div class="col-7">{{ formatCamelCase(paymentHistory?.accountKyc?.subServiceType)}}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.AREA' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.areaName | hasValue }}</div>
                </div>

                <div class="row">
                    <div class="col-5">{{ 'PAYMENT_HISTORY.REGION' | translate }}</div>
                    <div class="col-7">{{ paymentHistory?.customer?.regionName | hasValue }}</div>
                </div>
            </div>
        </div>

        <div class="card container main-col">
            <div class="row">
                <div class="col-5">
                    <p class="card-title">{{ 'PAYMENT_HISTORY.PAYMENT_INFORMATION' | translate }}</p>
                </div>
                <div class="col-7">
                    <div class="line-2"></div>
                </div>
            </div>

            <div class="row">
                <div class="col-3">{{ 'PAYMENT_HISTORY.TRANSACTION_ID' | translate }}</div>
                <div class="col-9">{{ paymentHistory?.transactionId | hasValue }}</div>
            </div>

            <div class="row">
                <div class="col-5">{{ 'PAYMENT_HISTORY.AMOUNT' | translate }}</div>
                <div class="col-7">{{ paymentHistory?.amount != null ? ((paymentHistory?.amount | number:'1.0-0') + ' ' + currency) : '----' }}</div>
            </div>

            <div class="row">
                <div class="col-5">{{ 'PAYMENT_HISTORY.PROCESS_FEES' | translate }}</div>
                <div class="col-7">{{ paymentHistory?.processFees != null ? ((paymentHistory?.processFees | number:'1.2-2') + ' ' + currency) : '----' }}</div>
            </div>

            <div class="row">
                <div class="col-5">{{ 'PAYMENT_HISTORY.PAYMENT_STATUS' | translate }}</div>
                <div *ngIf="paymentHistory?.paymentStatus" class="col-7 building-status building-status-margin-left"
                    [ngClass]="{'assigned-building': paymentHistory?.paymentStatus == 'Refunded' || paymentHistory?.paymentStatus == 'Unknown', 
                                'rejected-building': paymentHistory?.paymentStatus == 'Failed', 
                                'approved-building': paymentHistory?.paymentStatus == 'Success' || paymentHistory?.paymentStatus == 'ReadyForPayout',
                                'submitted-building': paymentHistory?.paymentStatus=='Pending'}"
                    >
                    {{ ('COMMON.PAYMENT_STATUS.' + paymentHistory?.paymentStatus | uppercase | translate) }}
                </div>
                <div *ngIf="!paymentHistory?.paymentStatus" class="col-7 building-status-margin-left">
                    ----
                </div>
            </div>

            <div class="row">
                <div class="col-5">{{ 'PAYMENT_HISTORY.DATE_TIMESTAMP' | translate }}</div>
                <div class="col-7">{{ paymentHistory?.endTime | utcDate }}</div>
            </div>

            <div class="row">
                <div class="col-3">{{ 'PAYMENT_HISTORY.MAP_VENDOR' | translate }}</div>
                <div class="col-9">{{ paymentHistory?.mapVendor | hasValue }}</div>
            </div>
        </div>
        <div class="main-col"></div>
    </div>
</div>
